import moment from 'moment';
const ICAL_DATE_FORMAT = 'YYYYMMDDTHHmmss';
export function iCalDateToJsDate(iCalDate) {
  return moment(iCalDate, ICAL_DATE_FORMAT).toDate();
}
export function jsDateToiCalDate(jsDate) {
  return moment(jsDate).format(ICAL_DATE_FORMAT);
}
export function iCalDateToMoment(iCalDate) {
  return moment(iCalDate, ICAL_DATE_FORMAT);
}
export function momentToiCalDate(moment) {
  return moment.format(ICAL_DATE_FORMAT);
}
export function iCalDateToDateInput(iCalDate) {
  const year = iCalDate.slice(0, 4);
  const month = iCalDate.slice(4, 6);
  const day = iCalDate.slice(6, 8);
  return `${year}-${month}-${day}`;
}
export function dateInputToiCalDate(dateInput) {
  const [year, month, day] = dateInput.split('-');
  return `${year}${month}${day}T000000`;
}